import { AccordionContent } from "./AccordionContent";
import { AccordionHeader } from "./AccordionHeader";
import { AccordionHeaderIcon } from "./AccordionHeaderIcon";
import { AccordionRoot } from "./AccordionRoot";

export const Accordion = {
  Root: AccordionRoot,
  Header: AccordionHeader,
  HeaderIcon: AccordionHeaderIcon,
  Content: AccordionContent,
};
